import Drawer from '@mui/material/Drawer'
import { styled } from '@mui/material/styles'

export default styled(Drawer)(({ theme, ownerState }) => {
  const { boxShadows, transitions, breakpoints, functions } = theme
  const { transparentSidenav, miniSidenav } = ownerState

  const sidebarWidth = 280
  const { xxl } = boxShadows
  const { pxToRem } = functions

  // Styles for the sidenav when miniSidenav={false}
  const drawerOpenStyles = () => ({
    transform: 'translateX(0)',
    background: 'linear-gradient(180deg, #0c2350 0%, #081a3a 100%)',
    // height: '123vh', // Full height
    // position: 'fixed', // Fix position
    transition: transitions.create('transform', {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.down('sm')]: {
      width: '100%', // Full width on small screens
      borderRadius: 0, // Flat edges for small screens
    },

    [breakpoints.up('xl')]: {
      boxShadow: transparentSidenav ? 'none' : xxl,
      marginBottom: transparentSidenav ? 0 : 'inherit',
      left: -15,
      width: sidebarWidth,
      borderRadius: 5,
      transition: transitions.create(['width', 'background-color'], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },
  })

  // Styles for the sidenav when miniSidenav={true}
  const drawerCloseStyles = () => ({
    transform: `translateX(${pxToRem(-320)})`,
    background: 'linear-gradient(180deg, #0c2350 0%, #081a3a 100%)',
    // height: '125vh', // Full height
    // position: 'fixed', // Fix position
    transition: transitions.create('transform', {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.down('sm')]: {
      width: pxToRem(96), // Adjusted width for small screens
      overflowX: 'hidden',
      borderRadius: 0, // Flat edges for small screens
    },

    [breakpoints.up('xl')]: {
      boxShadow: transparentSidenav ? 'none' : xxl,
      marginBottom: transparentSidenav ? 0 : 'inherit',
      left: 0,
      width: pxToRem(96),
      overflowX: 'hidden',
      borderRadius: 0,
      transition: transitions.create(['width', 'background-color'], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
    },
  })

  return {
    '& .MuiDrawer-paper': {
      boxShadow: xxl,
      border: 'none',

      ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
    },
  }
})
